import React, { useRef, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Turn as Hamburger } from "hamburger-react";
const Navbar = ({ HomeRef, ServiceRef, ContactRef }) => {
  const navigate = useNavigate();

  const [menuActive, setMenuActive] = useState(false);
  const showMenu = () => {
    setMenuActive(!menuActive);
  };

  const LogoRef = useRef(null);
  return (
    <Container>
      <Left
        ref={LogoRef}
        onClick={() => {
          window.location.reload();
          navigate("/");
        }}
      >
        <img src="/images/logo1.png" alt="" />
      </Left>

      <Menu>
        <Link
          onClick={() =>
            HomeRef.current.scrollIntoView({
              behavior: "smooth",
            })
          }
        >
          Home
        </Link>
        <Link
          onClick={() =>
            ServiceRef.current.scrollIntoView({
              behavior: "smooth",
            })
          }
        >
          Services
        </Link>
        <Link to={"/talent"}>Talent</Link>
        <Link to={"/work"}>Work</Link>
        <Link
          onClick={() => {
            ContactRef.current.scrollIntoView({
              behavior: "smooth",
            });
          }}
        >
          Contact
        </Link>
      </Menu>

      <Hamburger
        color="#fff"
        size={"22"}
        onToggle={showMenu}
        toggled={menuActive}
      />

      <div className={menuActive ? "hamburgerMenu active" : "hamburgerMenu"}>
        <ul className="menu-items">
          <li
            className="item-text"
            onClick={() => {
              HomeRef.current.scrollIntoView({
                behavior: "smooth",
              });
              setMenuActive(false);
            }}
          >
            Home
          </li>
          <li
            className="item-text"
            onClick={() => {
              ServiceRef.current.scrollIntoView({
                behavior: "smooth",
              });
              setMenuActive(false);
            }}
          >
            Services
          </li>
          <li className="item-text" onClick={() => navigate("/talent")}>
            Talent
          </li>
          <li className="item-text" onClick={() => navigate("/work")}>
            Work
          </li>
          <li
            className="item-text"
            onClick={() => {
              ContactRef.current.scrollIntoView({
                behavior: "smooth",
              });
              setMenuActive(false);
            }}
          >
            Contact
          </li>
        </ul>
      </div>
    </Container>
  );
};

const Container = styled.div`
  background-color: #161616;
  position: fixed;
  width: 100vw;
  height: 100px;
  padding: 10px 20px;
  top: 0;
  display: flex;
  align-items: center;

  position: fixed;

  z-index: 1;

  @media only screen and (max-width: 814px) {
    justify-content: space-between;
    height: 85px;
  }

  .hamburgerMenu {
    background-color: #fff;
    width: 250px;
    height: calc(100vh - 105px);
    position: fixed;
    top: 105px;
    right: -100%;
    color: black;
    display: flex;
    justify-content: center;
    transition: 850ms;
    z-index: 1000;
    -webkit-box-shadow: 10px 10px 57px -15px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 10px 10px 57px -15px rgba(0, 0, 0, 0.75);
    box-shadow: 10px 10px 57px -15px rgba(0, 0, 0, 0.75);
    .menu-items {
      width: 80%;
      text-decoration: none;
      list-style-type: none;
      .item-text {
        margin-top: 20px;
        font-size: 13px;
        cursor: pointer;
      }
    }
  }
  .hamburgerMenu.active {
    right: 0;
    transition: 350ms;
  }

  .hamburger-react {
    margin-right: 20px;
  }

  @media only screen and (min-width: 815px) {
    .hamburger-react {
      display: none;
    }
  }
`;

const Left = styled.div`
  width: 35%;
  cursor: pointer;
  img {
    width: 12%;
  }
  @media only screen and (max-width: 814px) {
    width: 65px;
    img {
      width: 100%;
    }
  }
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 500px;

  a {
    text-decoration: none;
    font-size: 15px;
    color: #ffff;
    font-weight: 800;
    letter-spacing: 1.2px;
    cursor: pointer;
    &:hover {
      color: #c9a34e;
      transition: 0.3s all ease-in-out;
    }
  }

  @media only screen and (max-width: 814px) {
    display: none;
  }
`;

export default Navbar;
